<div class="RelatedPosts">
  <h2 class="Like">You might also like</h2>
  <ul class="Cards">
    <li *ngFor="let similarDoc of similarDocuments">
      <related-doc [relatedDoc]="similarDoc" [relationType]="'similar'"></related-doc>
    </li>
  </ul>
</div>